import { ReactNode } from "react";
import CenteredArea from "./centered-area";
import StatusText from "./status-text";

type LoadingFallbackProps = {
  children?: ReactNode;
};

export default function LoadingFallback({ children }: LoadingFallbackProps) {
  return (
    <CenteredArea>
      <StatusText variant="loading">{children ? children : "Loading..."}</StatusText>
    </CenteredArea>
  );
}
